import Core from "./Core"
import List from "./List"
import SearchQuestion from "./SearchQuestion"
import SurveyAnswer from "./SurveyAnswer"

export default {
  namespaced: true,
  modules: {
    Core,
    List,
    SearchQuestion,
    SurveyAnswer
  }
}
